import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { getTranslate } from 'react-localize-redux'
import history from '../../history'
import { getOrganisationDetails } from '../../redux/actions/organisationActions'

import OrganisationDetail from '../../components/organisation/organisation-detail'
import Loading from '../../components/loading'

class OrganisationDetailPage extends Component {
  componentWillMount() {
    const organisationId = this.props.match.params.organisationId
    this.props.getOrganisationDetails(organisationId)
  }

  handleBack = () => {
    history.push('/dashboard')
  }

  render() {
    const { translate, organisation, loading } = this.props

    if (loading) {
      return <Loading />
    }

    return (
      <OrganisationDetail
        translate={translate}
        organisation={organisation}
        onBack={this.handleBack}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  organisation: state.organisationReducer.organisationDetails,
  translate: getTranslate(state.localeReducer),
  loading: state.organisationReducer.loading,
  ...state
})

const mapDispatchToProps = {
  getOrganisationDetails
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(OrganisationDetailPage)
